module.exports = __webpack_public_path__ + "static/media/vb_logo.4b0dc218.svg";